"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _Product = _interopRequireDefault(require("@deosite/ui-entities/Product"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _Container = _interopRequireDefault(require("@commerce-ui/core2/Container"));
var _Grid = _interopRequireDefault(require("@commerce-ui/core2/Grid"));
var _LinkRaw = _interopRequireDefault(require("@commerce-ui/core2/LinkRaw"));
var _Selectable = _interopRequireDefault(require("@commerce-ui/core2/Selectable"));
var _QuantityPicker = require("@commerce-ui/core2/QuantityPicker");
var _ImageSliderUi = _interopRequireWildcard(require("../ImageSliderUi"));
var _Image = _interopRequireWildcard(require("../Image"));
var _ImageZoomableUi = _interopRequireDefault(require("../ImageZoomableUi"));
var _ProductDescriptionAccordion = _interopRequireDefault(require("./ProductDescriptionAccordion"));
var _ProductDescription2Columns = _interopRequireDefault(require("./ProductDescription2Columns"));
var _CollectionButton = _interopRequireDefault(require("./CollectionButton"));
var _RouteContext = require("@deosite/lib/RouteContext");
var _useCartModifier2 = _interopRequireDefault(require("@deosite/api/hooks/REST/useCartModifier"));
var _useOptionPicker2 = _interopRequireDefault(require("@deosite/api/hooks/REST/useOptionPicker"));
var _usePriceWithCurrency = _interopRequireDefault(require("@deosite/api/hooks/common/usePriceWithCurrency"));
var _usePriceFormatter = _interopRequireDefault(require("@deosite/api/hooks/common/usePriceFormatter"));
var _useRecentlyViewedProducts = require("@deosite/api/hooks/common/useRecentlyViewedProducts");
var _useProductHeadOptions = require("@deosite/api/hooks/common/useProductHeadOptions");
var _useSelectScrollableStack = _interopRequireWildcard(require("@deosite/api/hooks/common/useSelectScrollableStack"));
var _LanguageProvider = require("@deosite/api/hooks/common/LanguageProvider");
var _countCatalogPrice = _interopRequireDefault(require("@deosite/helpers/countCatalogPrice"));
var _isDiscount = _interopRequireDefault(require("@deosite/helpers/isDiscount"));
var _percentDecrease = _interopRequireDefault(require("@deosite/helpers/percentDecrease"));
var _getLowProductAvailability = _interopRequireDefault(require("@deosite/helpers/getLowProductAvailability"));
var _getAvailabilityDate = _interopRequireDefault(require("@deosite/helpers/getAvailabilityDate"));
var _showLowestPrice = _interopRequireDefault(require("@deosite/helpers/showLowestPrice"));
var _hasStoreAdditionalFunctionalities = _interopRequireDefault(require("@deosite/helpers/hasStoreAdditionalFunctionalities"));
var _isGlobalEnvEnabled = _interopRequireDefault(require("@deosite/helpers/isGlobalEnvEnabled"));
var _TokenProvider = require("@deosite/api/hooks/common/TokenProvider");
var _WishlistProvider = require("@deosite/api/hooks/REST/WishlistProvider");
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _HitProductPage = _interopRequireDefault(require("../Hit/HitProductPage"));
var _ButtonRaw = _interopRequireDefault(require("@commerce-ui/core2/ButtonRaw"));
var _HitProvider = require("../Hit/provider/HitProvider");
var _getPromoCategory = _interopRequireDefault(require("@deosite/helpers/getPromoCategory"));
var _DialogUi = _interopRequireDefault(require("../DialogUi"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ChevronLeftIcon = function ChevronLeftIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.883 13.438l6.542 6.99-.876.82-7.87-8.41 7.87-8.41.876.82-6.542 6.99H20.5v1.2H4.883z",
    fill: "#2E4557"
  }));
};
ChevronLeftIcon.defaultProps = {
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var CloseIcon = function CloseIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.347 20.838l-15-15 .848-.848 15 15-.848.848z"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.347 19.838l15-15 .848.849-15 15-.848-.849z"
  }));
};
CloseIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var ProductHead = function ProductHead(props) {
  var _sale$left, _sale$maxQtyPerClient, _product$category, _sale$maxQtyPerClient2, _product$price$specia, _additionalStyles$qty, _additionalStyles$qty2, _additionalStyles$sku, _sale$price;
  var productCategory = props.productCategory,
    photoGrid = props.photoGrid,
    button = props.button,
    qtyWithButton = props.qtyWithButton,
    additionalStyles = props.additionalStyles,
    isMobile = props.isMobile,
    imageOverlayOpacity = props.imageOverlayOpacity,
    roundness = props.roundness,
    buttonArrowLeft = props.buttonArrowLeft,
    buttonArrowRight = props.buttonArrowRight,
    optionsSelector = props.optionsSelector,
    productFromOutlet = props.productFromOutlet,
    _props$showProducerAn = props.showProducerAndCollectionInfo,
    showProducerAndCollectionInfo = _props$showProducerAn === void 0 ? false : _props$showProducerAn,
    _props$showDescriptio = props.showDescriptionAsAccordion,
    showDescriptionAsAccordion = _props$showDescriptio === void 0 ? true : _props$showDescriptio,
    _props$showAdditional = props.showAdditionalFeeInfo,
    showAdditionalFeeInfo = _props$showAdditional === void 0 ? false : _props$showAdditional,
    brandCategories = props.brandCategories,
    rootCategories = props.rootCategories,
    wishlistIcon = props.wishlistIcon,
    wishlistOutlineIcon = props.wishlistOutlineIcon,
    isProductPageHit = props.isProductPageHit;
  var priceFormatter = (0, _usePriceFormatter["default"])();
  var _useToken = (0, _TokenProvider.useToken)(),
    token = _useToken.token;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var _useHit = (0, _HitProvider.useHit)(!isProductPageHit),
    sale = _useHit.sale,
    hitIsActive = _useHit.isActive;
  var translations = {
    description: (0, _langLibrary["default"])("Product description"),
    technicalData: (0, _langLibrary["default"])("Technical data"),
    shortDescription: (0, _langLibrary["default"])("Details"),
    outOfStock: (0, _langLibrary["default"])("Out of stock"),
    lastItemsInStock: (0, _langLibrary["default"])("Last items in stock"),
    catalogPrice: (0, _langLibrary["default"])("Catalog price"),
    quantity: (0, _langLibrary["default"])("Quantity"),
    addToCart: (0, _langLibrary["default"])("add to cart"),
    bonusPoints: (0, _langLibrary["default"])("bonus ePoints"),
    sale: (0, _langLibrary["default"])("Sale"),
    black: (0, _langLibrary["default"])("Cyber week"),
    "new": (0, _langLibrary["default"])("New arrival"),
    brexit: (0, _langLibrary["default"])("Brexit"),
    productAsteriskInfo: (0, _langLibrary["default"])("product available in different variant"),
    final_price: (0, _langLibrary["default"])("price"),
    price: (0, _langLibrary["default"])("price"),
    producer: (0, _langLibrary["default"])("Producer"),
    brand: (0, _langLibrary["default"])("Brand"),
    height: (0, _langLibrary["default"])("Height [cm]"),
    dajar_collection: (0, _langLibrary["default"])("Dajar collection"),
    deliveryTime: (0, _langLibrary["default"])("Delivery time"),
    shippingTime: (0, _langLibrary["default"])("Shipping time info"),
    carryPackage: (0, _langLibrary["default"])("Carry package"),
    freeShipping: (0, _langLibrary["default"])("Free delivery"),
    shippingPrice: (0, _langLibrary["default"])("Shipping cost with standard delivery price"),
    availabilityInfo: (0, _langLibrary["default"])("The product will be available"),
    priceIncludesTax: (0, _langLibrary["default"])("Price includes tax"),
    freeDeliveryInfo: (0, _langLibrary["default"])("Free delivery PDP info {{freeDeliveryFrom}}", {
      freeDeliveryFrom: "300 ".concat(priceFormatter.currencySymbol)
    }),
    weight: (0, _langLibrary["default"])("Weight [kg]"),
    lowestPrice: (0, _langLibrary["default"])("Lowest price info"),
    offerValid: (0, _langLibrary["default"])("Offer valid while stocks last"),
    addToWishlist: (0, _langLibrary["default"])("Add product to wishlist"),
    removeFromWishList: (0, _langLibrary["default"])("Remove from wishlist"),
    productInWishlist: (0, _langLibrary["default"])("Product on wishlist"),
    productCode: (0, _langLibrary["default"])("product code"),
    wishlistTooltip: (0, _langLibrary["default"])("Wishlist inactive tooltip"),
    hitOfWeek: (0, _langLibrary["default"])("Hit of the week"),
    hitOfMonth: (0, _langLibrary["default"])("Hit of the month"),
    outlet: (0, _langLibrary["default"])("Outlet"),
    phone: (0, _langLibrary["default"])("Phone"),
    hitDay: (0, _langLibrary["default"])("Hit of the day"),
    onlyLeftInStock: (0, _langLibrary["default"])("Only {{qty}} left in stock", {
      qty: hitIsActive ? (_sale$left = sale === null || sale === void 0 ? void 0 : sale.left) !== null && _sale$left !== void 0 ? _sale$left : 0 : 0
    }),
    maxAvailableQtyHit: (0, _langLibrary["default"])("Available qty for person in hit {{qty}}", {
      qty: (_sale$maxQtyPerClient = sale === null || sale === void 0 ? void 0 : sale.maxQtyPerClient) !== null && _sale$maxQtyPerClient !== void 0 ? _sale$maxQtyPerClient : 1
    }),
    additionalPromoLabel: (0, _langLibrary["default"])("additional_promo_label"),
    safetyTitle: (0, _langLibrary["default"])("safety_title"),
    safetyDescription: (0, _langLibrary["default"])("safety_description")
  };
  var promoLabels = [translations.hitOfWeek, translations.hitOfMonth, translations["new"], translations.outlet, translations.black];
  var blackNovemberId = 4;
  var _useOptionPicker = (0, _useOptionPicker2["default"])(props.product),
    product = _useOptionPicker.product,
    options = _useOptionPicker.options,
    selectedValues = _useOptionPicker.selectedValues;
  var currentProductIsHit = isProductPageHit ? props.product.sku === product.sku : false;
  var priceWithCurrency = (0, _usePriceWithCurrency["default"])();
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var _useWishlist = (0, _WishlistProvider.useWishlist)(),
    addToWishlist = _useWishlist.addToWishlist,
    removeFromWishlist = _useWishlist.removeFromWishlist,
    accountWishlist = _useWishlist.accountWishlist;
  var isFirstRun = (0, _react.useRef)({
    first: true,
    product: product
  });
  var counter = (0, _react.useRef)(0);
  var isInWishlist = accountWishlist === null || accountWishlist === void 0 ? void 0 : accountWishlist.includes(product.sku);
  var currentProductGotAdditionalLabel = (0, _getPromoCategory["default"])({
    language: language.language,
    ids: product === null || product === void 0 ? void 0 : (_product$category = product.category) === null || _product$category === void 0 ? void 0 : _product$category.ids
  });
  (0, _react.useEffect)(function () {
    if (isFirstRun.current.first && product) {
      isFirstRun.current = {
        first: false,
        product: product
      };
      return;
    }
    counter.current += 1;
    history.pushState("", product.name, product.url);
  }, [product.url]);
  if (typeof window !== "undefined") {
    window.onpopstate = function (event) {
      if (counter.current > 0) {
        history.go(counter.current * -1);
        counter.current = 0;
      }
    };
  }
  var quantityPicker = (0, _QuantityPicker.useQuantityPicker)({
    selectOptionsAmount: 9,
    maxValue: isProductPageHit ? (_sale$maxQtyPerClient2 = sale === null || sale === void 0 ? void 0 : sale.maxQtyPerClient) !== null && _sale$maxQtyPerClient2 !== void 0 ? _sale$maxQtyPerClient2 : 0 : global.__appConfig__.quantityPickerMaxValue
  });
  var _useCartModifier = (0, _useCartModifier2["default"])({
      product: product,
      isProductPageHit: currentProductIsHit,
      categoryName: productCategory === null ? undefined : productCategory.name,
      onSuccess: function onSuccess() {
        quantityPicker.reset();
      }
    }),
    loading = _useCartModifier.loading,
    add = _useCartModifier.add;
  var outOfStock = (0, _getLowProductAvailability["default"])(product.availability.level);
  var lowAvailabilityLevel = (0, _isGlobalEnvEnabled["default"])({
    globalEnv: global.__appConfig__.pdpLastItemsStockVisibility,
    language: language
  }) && (0, _getLowProductAvailability["default"])(product.availability.level, false);
  var _useState = (0, _react.useState)(0),
    selectedImageIndex = _useState[0],
    setSelectedImageIndex = _useState[1];
  (0, _useRecentlyViewedProducts.useRecentlyViewedProducts)(product);
  var _useProductHeadOption = (0, _useProductHeadOptions.useProductHeadOptions)(),
    updateActiveProduct = _useProductHeadOption.updateActiveProduct;
  (0, _react.useEffect)(function () {
    updateActiveProduct(product);
    setSelectedImageIndex(0);
  }, [product]);
  var productImages = product.images.map(function (image) {
    return _objectSpread(_objectSpread({}, image), {}, {
      id: image.originalSrc
    });
  });
  var productThumbnails = product.images.map(function (image) {
    return _objectSpread(_objectSpread({}, image), {}, {
      id: image.originalSrc
    });
  });
  var imageSlider = (0, _ImageSliderUi.useImageSlider)({
    images: productImages,
    onChange: function onChange(index) {
      setSelectedImageIndex(index);
    },
    active: selectedImageIndex
  });
  var thumbnails = photoGrid ? null : (0, _useSelectScrollableStack.useSelectScrollableStack)({
    options: productThumbnails,
    value: productImages[selectedImageIndex] || null,
    allowEmpty: false,
    onChange: function onChange(_, index) {
      setSelectedImageIndex(index);
    }
  });
  var shippingLimitPrice = global.__appConfig__.shippingLimitPrices[language.language];
  var productPrice = (_product$price$specia = product.price.special) !== null && _product$price$specia !== void 0 ? _product$price$specia : product.price.regular;
  var shippingLimitMinusPrice = shippingLimitPrice - productPrice;
  var availabilityDate = (outOfStock || !product.isVisible) && (0, _getAvailabilityDate["default"])(product, translations.availabilityInfo);
  var disableProductForHit = isProductPageHit && (!(sale !== null && sale !== void 0 && sale.left) || (sale === null || sale === void 0 ? void 0 : sale.left) === 0 || !hitIsActive);
  var addToCartButton = /*#__PURE__*/_react["default"].cloneElement(button, {
    sx: {
      $size: "large",
      width: "100%"
    },
    "data-test": "add-to-cart",
    isLoading: loading,
    onClick: function onClick() {
      if (!loading && !outOfStock) {
        add(quantityPicker.amount);
      }
    },
    disabled: outOfStock || !product.isVisible || product.price.regular === 0 || disableProductForHit
  }, translations.addToCart);
  var availabilityInfo = product.availability.level && (outOfStock || lowAvailabilityLevel || !product.isVisible) && __jsx(_Box["default"], null, __jsx(_Box["default"], {
    sx: {
      font: "body2",
      color: "main",
      display: qtyWithButton ? "none" : "block"
    }
  }, translations.quantity), __jsx(_Box["default"], {
    sx: {
      font: (_additionalStyles$qty = additionalStyles === null || additionalStyles === void 0 ? void 0 : additionalStyles.qtyLabelFont) !== null && _additionalStyles$qty !== void 0 ? _additionalStyles$qty : "xs",
      color: (_additionalStyles$qty2 = additionalStyles === null || additionalStyles === void 0 ? void 0 : additionalStyles.qtyLabelColor) !== null && _additionalStyles$qty2 !== void 0 ? _additionalStyles$qty2 : "orange"
    }
  }, outOfStock || !product.isVisible ? availabilityDate !== null ? availabilityDate : translations.outOfStock : translations.lastItemsInStock));
  var labelStyles = {
    backgroundColor: "negative",
    color: "white",
    width: 110,
    height: 26,
    borderRadius: 100,
    font: "xs",
    textAlign: "center",
    marginY: "s7",
    textDecoration: "uppercase"
  };
  var blackLabelStyles = {
    backgroundColor: "black",
    color: "white",
    width: 110,
    height: 26,
    borderRadius: 100,
    font: "xs",
    textAlign: "center",
    marginY: "s7",
    textDecoration: "uppercase"
  };
  var arrowsForMobile = isMobile && props.arrowsForMobile;
  var _useState2 = (0, _react.useState)(false),
    photoGridVisible = _useState2[0],
    setPhotoGridVisible = _useState2[1];
  (0, _react.useEffect)(function () {
    if (isMobile) {
      setPhotoGridVisible(false);
    } else if (photoGrid) {
      setPhotoGridVisible(true);
    }
  }, [isMobile]);
  var showLowestPrice = global.__appConfig__.showLowestPrice && language.language ? (0, _showLowestPrice["default"])({
    showLowestPriceId: parseInt(global.__appConfig__.showLowestPrice[language.language]),
    price: product.price
  }) : false;
  var ref = (0, _react.useRef)(null);
  var _useState3 = (0, _react.useState)(false),
    showProducent = _useState3[0],
    setShowProducent = _useState3[1];
  var Producer = function Producer() {
    var _showProducent$addres, _showProducent$addres2, _showProducent$email;
    return showProducent && __jsx(_DialogUi["default"], {
      isOpen: !!showProducent,
      anchoredTo: ref,
      onClose: function onClose() {
        if (!showProducent) return;
        setShowProducent(false);
      },
      withScrollBar: true,
      sx: {
        minWidth: 300,
        minHeight: 100,
        height: "auto",
        width: "auto",
        position: "relative"
      }
    }, showProducent && __jsx(_Box["default"], {
      sx: {
        background: "white",
        border: "2px solid #ccd4da",
        borderRadius: 8,
        padding: 20
      }
    }, __jsx(_Box["default"], {
      sx: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }
    }, __jsx(_Box["default"], {
      as: "span",
      sx: {
        font: "base_sans_bold",
        color: "producerGreyLight",
        textTransform: "uppercase"
      }
    }, translations.producer, " ", showProducent.producer), __jsx(_Box["default"], {
      onClick: function onClick() {
        return setShowProducent(null);
      }
    }, __jsx(CloseIcon, null))), __jsx(_Box["default"], {
      sx: {
        marginTop: 10,
        color: "producerGrey"
      }
    }, __jsx(_Box["default"], null, " ", showProducent === null || showProducent === void 0 ? void 0 : (_showProducent$addres = showProducent.address) === null || _showProducent$addres === void 0 ? void 0 : (_showProducent$addres2 = _showProducent$addres.split("\n")) === null || _showProducent$addres2 === void 0 ? void 0 : _showProducent$addres2.map(function (line, index) {
      return __jsx(_react["default"].Fragment, {
        key: index
      }, line, __jsx("br", null));
    })), __jsx(_Box["default"], {
      sx: {
        marginTop: 2,
        a: {
          color: "producerGrey",
          outline: "none"
        }
      }
    }, showProducent !== null && showProducent !== void 0 && (_showProducent$email = showProducent.email) !== null && _showProducent$email !== void 0 && _showProducent$email.includes("@") ? __jsx(_react["default"].Fragment, null, "e-mail:", " ", __jsx("a", {
      href: "mailto:".concat(showProducent === null || showProducent === void 0 ? void 0 : showProducent.email)
    }, showProducent.email)) : __jsx(_react["default"].Fragment, null, "www:", " ", __jsx("a", {
      href: "http://".concat(showProducent === null || showProducent === void 0 ? void 0 : showProducent.email),
      target: "_blank"
    }, showProducent.email))), (showProducent === null || showProducent === void 0 ? void 0 : showProducent.phone) && __jsx(_Box["default"], null, translations.phone.toLowerCase(), ": ", showProducent.phone))));
  };
  return __jsx(_Box["default"], {
    sx: {
      mt: [0, null, null, "s8", "s10"]
    }
  }, __jsx(Producer, null), __jsx(_Container["default"], {
    margin: [0, "containerMargin"]
  }, __jsx(_Grid["default"], {
    cols: 20
  }, __jsx(_Box["default"], {
    sx: {
      gridColumnStart: ["span 20", null, null, "span 12"],
      mb: ["s8", null, null, 0]
    }
  }, photoGridVisible ? __jsx(_Grid["default"], {
    cols: productImages.length > 3 ? 2 : 1,
    gap: "s5"
  }, productImages.map(function (image) {
    return __jsx(_ImageZoomableUi["default"], {
      zoom: productImages.length > 3 ? 3 : 2
    }, __jsx(_Image["default"], {
      overlay: true,
      overlayOpacity: imageOverlayOpacity,
      image: image,
      quality: global.__appConfig__.productThumbnailsQuality,
      cloudflareEnabled: global.__appConfig__.productThumbnailsCloudflareEnabled,
      roundness: roundness,
      zoomable: true,
      zoom: productImages.length > 3 ? 3 : 2
    }));
  })) : __jsx(_Box["default"], {
    sx: {
      pb: "100%",
      position: "relative",
      mb: "s3"
    }
  }, __jsx(_ImageSliderUi["default"], {
    controller: imageSlider,
    isMobile: isMobile,
    arrowsForMobile: arrowsForMobile,
    photogridMobile: photoGrid,
    sx: {
      position: "absolute",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      $image: {
        $objectFit: "contain",
        __props: {
          cloudflareEnabled: global.__appConfig__.bigImageCloudflareEnabled,
          quality: global.__appConfig__.bigImageQuality,
          sizes: "(max-width: 1535px) and (min-width: 960px) 768px, (max-width: 960px) and (min-width: 10px) 100vw, 1024px"
        }
      }
    }
  }), __jsx(_Box["default"], {
    sx: {
      background: "rgba(0, 0, 0, 0.03)",
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      zIndex: 1,
      pointerEvents: "none"
    }
  })), thumbnails && __jsx(_useSelectScrollableStack["default"], {
    controller: thumbnails,
    previousButton: function previousButton(_ref) {
      var isAtStart = _ref.isAtStart;
      return {
        button: /*#__PURE__*/_react["default"].cloneElement(buttonArrowLeft, {
          sx: {
            opacity: isAtStart ? 0 : 1,
            transition: "opacity .15s",
            pointerEvents: isAtStart ? "none" : "default"
          },
          "data-test": "left-arrow-small-image-slider"
        }),
        offset: -22
      };
    },
    nextButton: function nextButton(_ref2) {
      var isAtEnd = _ref2.isAtEnd;
      return {
        button: /*#__PURE__*/_react["default"].cloneElement(buttonArrowRight, {
          sx: {
            opacity: isAtEnd ? 0 : 1,
            transition: "opacity .10s",
            pointerEvents: isAtEnd ? "none" : "default"
          },
          "data-test": "right-arrow-small-image-slider"
        }),
        offset: -22
      };
    },
    sx: {
      $itemSize: 80,
      $gap: 4,
      $floatingElement: {
        height: "2px",
        bg: "main"
      }
    }
  }, __jsx(_Selectable["default"], {
    sx: {
      height: "80px",
      width: "80px",
      display: arrowsForMobile ? "none" : "block",
      img: {
        height: "80px",
        width: "80px"
      }
    }
  }, function (_ref3) {
    var option = _ref3.option;
    return __jsx(_Image["default"], {
      overlay: true,
      image: option,
      quality: global.__appConfig__.productThumbnailsQuality,
      cloudflareEnabled: global.__appConfig__.productThumbnailsCloudflareEnabled,
      sx: {
        height: "80px",
        width: "80px",
        cursor: "pointer"
      },
      minified: true
    });
  }))), __jsx(_Box["default"], {
    sx: {
      gridColumnStart: ["span 20", null, null, "span 1"]
    }
  }), __jsx(_Box["default"], {
    sx: {
      gridColumnStart: ["span 20", null, null, "span 7"]
    }
  }, currentProductIsHit && __jsx(_HitProductPage["default"], null), __jsx(_Container["default"], {
    margin: ["containerMargin", null, null, 15, 0]
  }, __jsx(_Box["default"], {
    sx: {
      display: "flex",
      justifyContent: productCategory !== null && productCategory !== void 0 && productCategory.name ? "space-between" : "flex-end",
      alignContent: "center"
    }
  }, (productCategory === null || productCategory === void 0 ? void 0 : productCategory.name) && __jsx(Link, {
    route: "category-page",
    params: productCategory
  }, __jsx(_LinkRaw["default"], {
    sx: {
      font: ["xs", null, null, qtyWithButton ? "xs" : "xs_underline"],
      color: "main",
      svg: {
        width: 15,
        height: 15,
        position: "relative",
        top: 3
      }
    }
  }, __jsx(_Box["default"], {
    sx: {
      mb: qtyWithButton ? "s7" : "s5"
    }
  }, __jsx(ChevronLeftIcon, null), __jsx(_Box["default"], {
    as: "span",
    sx: {
      ml: 5
    }
  }, productCategory.name)))), __jsx(_Box["default"], {
    sx: {
      color: isInWishlist ? "negative" : "main",
      width: 16,
      mr: "s6",
      alignSelf: "center"
    },
    "data-test": "wishlist"
  }, token ? __jsx(_Box["default"], {
    sx: {
      cursor: "pointer"
    },
    onClick: function onClick() {
      isInWishlist ? removeFromWishlist(product.sku) : addToWishlist(product.sku);
    }
  }, isInWishlist ? wishlistIcon : wishlistOutlineIcon) : __jsx(_Box["default"], null, __jsx(_Tooltip["default"], {
    text: translations.wishlistTooltip
  }, wishlistOutlineIcon)))), product.labelText && __jsx(_Box["default"], {
    sx: {
      font: "heading3",
      color: "positive"
    }
  }, translations["new"]), currentProductIsHit && sale && (0, _isDiscount["default"])(product.price.special || product.price.regular, sale.price) && __jsx(_Box["default"], {
    sx: {
      font: "heading3",
      color: "negative"
    }
  }, translations.sale, " -", (0, _percentDecrease["default"])(product.price.special || product.price.regular, sale.price), "%"), !currentProductIsHit && (0, _isDiscount["default"])(product.price.regular, product.price.special) && __jsx(_Box["default"], {
    sx: {
      font: "heading3",
      color: "negative"
    }
  }, translations.sale, " -", (0, _percentDecrease["default"])(product.price.regular, product.price.special), "%"), __jsx(_Box["default"], {
    as: "h1",
    sx: {
      font: "l_normal",
      color: "main"
    }
  }, product.name), __jsx(_Box["default"], {
    sx: {
      font: (_additionalStyles$sku = additionalStyles === null || additionalStyles === void 0 ? void 0 : additionalStyles.skuFont) !== null && _additionalStyles$sku !== void 0 ? _additionalStyles$sku : "s_sans",
      textTransform: "uppercase",
      color: additionalStyles !== null && additionalStyles !== void 0 && additionalStyles.skuColor ? additionalStyles === null || additionalStyles === void 0 ? void 0 : additionalStyles.skuColor : qtyWithButton ? "main" : "neutral700",
      mt: qtyWithButton ? "s5" : 0
    }
  }, translations.productCode, " ", product.sku), (currentProductIsHit || product.promoLabelIndex !== undefined && product.promoLabelIndex !== blackNovemberId) && __jsx(_ButtonRaw["default"], {
    sx: _objectSpread(_objectSpread({}, labelStyles), {}, {
      mr: "s5"
    })
  }, currentProductIsHit ? translations.hitDay : promoLabels[product.promoLabelIndex]), product.promoLabelIndex === blackNovemberId && __jsx(_ButtonRaw["default"], {
    sx: _objectSpread(_objectSpread({}, blackLabelStyles), {}, {
      mr: "s5"
    })
  }, promoLabels[product.promoLabelIndex]), currentProductGotAdditionalLabel && __jsx(_ButtonRaw["default"], {
    sx: _objectSpread({}, labelStyles)
  }, translations.additionalPromoLabel), showProducerAndCollectionInfo && __jsx(_Box["default"], {
    sx: {
      mt: "s7",
      display: "flex",
      flexDirection: ["column", null, "row"]
    }
  }, __jsx(_Box["default"], {
    sx: {
      display: product.producer ? "flex" : "none",
      font: "xs_caps",
      color: "main",
      height: 35,
      alignItems: "center"
    }
  }, __jsx(_Box["default"], {
    sx: {
      height: "100%",
      pt: 10
    }
  }, translations.producer, ":"), __jsx(_CollectionButton["default"], {
    ref: ref,
    setShowProducent: setShowProducent,
    product: product,
    isCollection: false,
    rootCategory: rootCategories[language.language],
    brandCategory: brandCategories[language.language]
  })), __jsx(_Box["default"], {
    sx: {
      display: product.collection.name ? "flex" : "none",
      font: "xs_caps",
      color: "main",
      height: 35,
      alignItems: "center",
      ml: product.producer ? [0, null, "s8"] : 0,
      mt: ["s6", null, 0]
    }
  }, __jsx(_Box["default"], {
    sx: {
      height: "100%",
      pt: 10
    }
  }, translations.dajar_collection, ":"), __jsx(_CollectionButton["default"], {
    product: product,
    isCollection: true,
    rootCategory: rootCategories[language.language],
    brandCategory: brandCategories[language.language]
  }))), __jsx(_Box["default"], {
    sx: {
      mb: qtyWithButton ? ["s9", null, null, "s11_2"] : "s9",
      mt: "s7"
    }
  }, __jsx(_Box["default"], {
    as: "p",
    sx: {
      font: qtyWithButton ? "xxl_sans" : "heading3",
      color: "main"
    }
  }, sale !== null && sale !== void 0 && sale.price || product.price.special ? __jsx(_Box["default"], {
    as: "span",
    sx: {
      textDecorationLine: "line-through",
      font: "l_normal"
    }
  }, priceWithCurrency(sale !== null && sale !== void 0 && sale.price && product.price.special ? product.price.special : product.price.regular)) : priceWithCurrency(product.price.regular), (language === null || language === void 0 ? void 0 : language.language) === "de" && __jsx(_Box["default"], {
    sx: {
      font: "xs",
      color: "neutral700",
      mt: "s4",
      a: {
        color: "neutral700",
        textDecoration: "none"
      }
    },
    dangerouslySetInnerHTML: {
      __html: translations.priceIncludesTax
    }
  })), (product.price.special || (sale === null || sale === void 0 ? void 0 : sale.price)) && __jsx(_Box["default"], {
    as: "p",
    sx: {
      font: qtyWithButton ? "xxl_sans" : "heading3",
      color: "negative"
    }
  }, priceWithCurrency((_sale$price = sale === null || sale === void 0 ? void 0 : sale.price) !== null && _sale$price !== void 0 ? _sale$price : product.price.special)), showLowestPrice && __jsx(_react["default"].Fragment, null, __jsx(_Box["default"], {
    sx: {
      font: "xs",
      mt: "s6"
    }
  }, translations.lowestPrice, ":", " ", priceWithCurrency(product.price.lowest)), productFromOutlet && __jsx(_Box["default"], {
    sx: {
      font: "xs",
      mt: "s6"
    }
  }, translations.offerValid)), product.epoints && __jsx(_Box["default"], {
    sx: {
      mt: "s5",
      backgroundColor: "lightOrange",
      color: "orange",
      font: "xs",
      borderRadius: "100px",
      display: "inline-block",
      py: "s3",
      px: "s6"
    }
  }, "+", product.epoints, " ", translations.bonusPoints)), __jsx(_Box["default"], {
    sx: {
      mb: options.length > 0 && qtyWithButton ? [0, null, null, "s12"] : 0
    }
  }, /*#__PURE__*/_react["default"].cloneElement(optionsSelector, {
    options: options,
    selectedValues: selectedValues
  })), options.find(function (option) {
    return option.showAsteriskInfo;
  }) && __jsx(_Box["default"], {
    sx: {
      font: "xs",
      color: "neutral700"
    }
  }, "* ", translations.productAsteriskInfo), language.language === global.__appConfig__.shopOffGB ? __jsx(_Box["default"], {
    sx: {
      color: "main",
      font: "xs"
    }
  }, translations.brexit) : __jsx(_react["default"].Fragment, null, qtyWithButton && availabilityInfo, __jsx(_Box["default"], {
    sx: {
      display: "flex",
      alignItems: "center",
      justifyContent: qtyWithButton ? "left" : "space-between",
      mb: "s7",
      mt: qtyWithButton ? "s7" : "s9"
    }
  }, __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "column",
      justifyContent: qtyWithButton ? "left" : "space-around"
    }
  }, !qtyWithButton && !currentProductIsHit && availabilityInfo, currentProductIsHit && __jsx(_react["default"].Fragment, null, __jsx(_Box["default"], {
    sx: {
      font: "s_sans",
      color: "black"
    }
  }, translations.quantity), " ", __jsx(_Box["default"], {
    sx: {
      font: "xs",
      color: "negative500"
    }
  }, translations.onlyLeftInStock))), __jsx(_Box["default"], {
    sx: {
      minWidth: qtyWithButton ? 158 : 140
    }
  }, /*#__PURE__*/_react["default"].cloneElement(props.quantityPicker, {
    controller: quantityPicker
  })), qtyWithButton && addToCartButton), !qtyWithButton && addToCartButton, (0, _hasStoreAdditionalFunctionalities["default"])(language) && !outOfStock && __jsx(_Box["default"], {
    sx: {
      font: "xs",
      color: "main",
      mt: "s3",
      pb: "s7"
    }
  }, translations.deliveryTime), currentProductIsHit && __jsx(_Box["default"], {
    sx: {
      font: "xs",
      mt: "s6"
    }
  }, translations.maxAvailableQtyHit), showAdditionalFeeInfo && __jsx(_Box["default"], {
    sx: {
      font: "body",
      color: "main",
      mt: "s9",
      pb: "s7",
      borderBottomStyle: "solid",
      borderBottomWidth: "1px",
      borderBottomColor: showDescriptionAsAccordion ? "white" : "neutral500"
    }
  }, translations.freeDeliveryInfo), global.__appConfig__.deliveryInfoEnabled && __jsx(_Box["default"], {
    sx: {
      font: "body2",
      color: "main",
      mt: "s6"
    }
  }, shippingLimitMinusPrice <= 0 ? __jsx(_Box["default"], null, translations.freeShipping) : __jsx(_Box["default"], null, translations.shippingPrice), __jsx(_Box["default"], null, translations.shippingTime), global.__appConfig__.packageCarryingInfoEnabled && __jsx(_Box["default"], null, translations.carryPackage))), showDescriptionAsAccordion && __jsx(_ProductDescriptionAccordion["default"], {
    productInfo: product.info,
    translations: translations,
    qtyWithButton: qtyWithButton,
    accordionLabelFont: additionalStyles === null || additionalStyles === void 0 ? void 0 : additionalStyles.accordionLabelFont
  }), !qtyWithButton && global.__appConfig__.pdpCatalogPriceVisibility[language.language] === 1 && __jsx(_Box["default"], {
    sx: {
      font: "xs",
      color: "neutral700",
      mt: "s7"
    }
  }, translations.catalogPrice, " ", priceWithCurrency((0, _countCatalogPrice["default"])(product.price.regular, 0.7))))))), !showDescriptionAsAccordion && __jsx(_ProductDescription2Columns["default"], {
    productInfo: product === null || product === void 0 ? void 0 : product.info
  }));
};
var _default = ProductHead;
exports["default"] = _default;